import { ProviderBuilder, EGenMode } from '@educraft/base';
import {
  GenList_DaysOfWeek__CS,
  GenList_DaysOfWeek__EN,
  GenList_DaysOfWeek__DE,
  GenList_DaysOfWeek__ES,
  GenList_DaysOfWeek__FR,
  GenList_DaysOfWeek__LA,
  GenList_DaysOfWeek__RU,
  GenList_DaysOfWeek__SK,
} from './generators/daysOfWeek';
import {
  GenList_Months__CS,
  GenList_Months__EN,
  GenList_Months__DE,
  GenList_Months__ES,
  GenList_Months__FR,
  GenList_Months__LA,
  GenList_Months__RU,
  GenList_Months__SK,
} from './generators/months';
import {
  GenList_Multiplication__2,
  GenList_Multiplication__3,
  GenList_Multiplication__4,
  GenList_Multiplication__5,
  GenList_Multiplication__6,
  GenList_Multiplication__7,
  GenList_Multiplication__8,
  GenList_Multiplication__9,
  GenList_Multiplication__10,
} from './generators/multiplication';
import {
  GenList_Chemistry__Elements_Number_Name__CS,
  GenList_Chemistry__Elements_Number_Name__EN,
  GenList_Chemistry__Elements_Number_Name__LA,
  GenList_Chemistry__Elements_Number_Symbol__CS,
  GenList_Chemistry__Elements_Name_Name__LA,
  GenList_Chemistry__Elements_Symbol_Name__CS,
  GenList_Chemistry__Elements_Symbol_Name__LA,
} from './generators/chemistry';
import { GenList_Cases__CS, GenList_Cases__LA } from './generators/cases';
import { GenList_PartsOfSpeech__CS, GenList_PartsOfSpeech__LA } from './generators/partsOfSpeech';
import {
  GenList_EnumeratedWords__B,
  GenList_EnumeratedWords__L,
  GenList_EnumeratedWords__M,
  GenList_EnumeratedWords__P,
  GenList_EnumeratedWords__S,
  GenList_EnumeratedWords__V,
  GenList_EnumeratedWords__Z,
} from './generators/enumeratedWords';
import {
  List__ElectroSpectrum__CS,
  List__ElectroSpectrum__EN,
  List__Planets__CS,
  List__Planets__EN,
  List__EarthLayers__CS,
  List__EarthLayers__EN,
  List__MohsScale__CS,
  List__MohsScale__EN,
  List__DigestivePath__CS,
  List__DigestivePath__EN,
  List__Presidents__CS,
  List__Presidents__EN,
  List__Alphabet__CS,
  List__Alphabet__EN,
  List__AlkaneSeries__CS,
  List__AlkaneSeries__EN,
  List__HumanLifeStages__CS,
  List__HumanLifeStages__EN,
} from './generators/general';

export function registerGenList(builder: ProviderBuilder): void {
  // Days of week
  builder.add(EGenMode.GenList, GenList_DaysOfWeek__CS, 'List.DaysOfWeek__CS');
  builder.add(EGenMode.GenList, GenList_DaysOfWeek__EN, 'List.DaysOfWeek__EN');
  builder.add(EGenMode.GenList, GenList_DaysOfWeek__DE, 'List.DaysOfWeek__DE');
  builder.add(EGenMode.GenList, GenList_DaysOfWeek__ES, 'List.DaysOfWeek__ES');
  builder.add(EGenMode.GenList, GenList_DaysOfWeek__FR, 'List.DaysOfWeek__FR');
  builder.add(EGenMode.GenList, GenList_DaysOfWeek__LA, 'List.DaysOfWeek__LA');
  builder.add(EGenMode.GenList, GenList_DaysOfWeek__RU, 'List.DaysOfWeek__RU');
  builder.add(EGenMode.GenList, GenList_DaysOfWeek__SK, 'List.DaysOfWeek__SK');

  // Months
  builder.add(EGenMode.GenList, GenList_Months__CS, 'List.Months__CS');
  builder.add(EGenMode.GenList, GenList_Months__EN, 'List.Months__EN');
  builder.add(EGenMode.GenList, GenList_Months__DE, 'List.Months__DE');
  builder.add(EGenMode.GenList, GenList_Months__ES, 'List.Months__ES');
  builder.add(EGenMode.GenList, GenList_Months__FR, 'List.Months__FR');
  builder.add(EGenMode.GenList, GenList_Months__LA, 'List.Months__LA');
  builder.add(EGenMode.GenList, GenList_Months__RU, 'List.Months__RU');
  builder.add(EGenMode.GenList, GenList_Months__SK, 'List.Months__SK');

  // Multiplication tables (2-10)
  builder.add(EGenMode.GenList, GenList_Multiplication__2, 'List.Multiplication__2');
  builder.add(EGenMode.GenList, GenList_Multiplication__3, 'List.Multiplication__3');
  builder.add(EGenMode.GenList, GenList_Multiplication__4, 'List.Multiplication__4');
  builder.add(EGenMode.GenList, GenList_Multiplication__5, 'List.Multiplication__5');
  builder.add(EGenMode.GenList, GenList_Multiplication__6, 'List.Multiplication__6');
  builder.add(EGenMode.GenList, GenList_Multiplication__7, 'List.Multiplication__7');
  builder.add(EGenMode.GenList, GenList_Multiplication__8, 'List.Multiplication__8');
  builder.add(EGenMode.GenList, GenList_Multiplication__9, 'List.Multiplication__9');
  builder.add(EGenMode.GenList, GenList_Multiplication__10, 'List.Multiplication__10');

  // Chemistry
  builder.add(EGenMode.GenList, GenList_Chemistry__Elements_Number_Name__CS,'List.Chemistry__Elements_Number_Name__CS');
  builder.add(EGenMode.GenList, GenList_Chemistry__Elements_Number_Name__EN,'List.Chemistry__Elements_Number_Name__EN');
  builder.add(EGenMode.GenList, GenList_Chemistry__Elements_Number_Name__LA,'List.Chemistry__Elements_Number_Name__LA');
  builder.add(EGenMode.GenList, GenList_Chemistry__Elements_Number_Symbol__CS, 'List.Chemistry__Elements_Number_Symbol__CS');
  builder.add(EGenMode.GenList, GenList_Chemistry__Elements_Name_Name__LA, 'List.Chemistry__Elements_Name_Name__LA');
  builder.add(EGenMode.GenList, GenList_Chemistry__Elements_Symbol_Name__CS, 'List.Chemistry__Elements_Symbol_Name__CS');
  builder.add(EGenMode.GenList, GenList_Chemistry__Elements_Symbol_Name__LA, 'List.Chemistry__Elements_Symbol_Name__LA');

  // Cases
  builder.add(EGenMode.GenList, GenList_Cases__CS, 'List.Cases__CS');
  builder.add(EGenMode.GenList, GenList_Cases__LA, 'List.Cases__LA');

  // Parts of speech
  builder.add(EGenMode.GenList, GenList_PartsOfSpeech__CS, 'List.PartsOfSpeech__CS');
  builder.add(EGenMode.GenList, GenList_PartsOfSpeech__LA, 'List.PartsOfSpeech__LA');

  // Enumerated words
  builder.add(EGenMode.GenList, GenList_EnumeratedWords__B, 'List.EnumeratedWords__B');
  builder.add(EGenMode.GenList, GenList_EnumeratedWords__L, 'List.EnumeratedWords__L');
  builder.add(EGenMode.GenList, GenList_EnumeratedWords__M, 'List.EnumeratedWords__M');
  builder.add(EGenMode.GenList, GenList_EnumeratedWords__P, 'List.EnumeratedWords__P');
  builder.add(EGenMode.GenList, GenList_EnumeratedWords__S, 'List.EnumeratedWords__S');
  builder.add(EGenMode.GenList, GenList_EnumeratedWords__V, 'List.EnumeratedWords__V');
  builder.add(EGenMode.GenList, GenList_EnumeratedWords__Z, 'List.EnumeratedWords__Z');

  // General lists
  builder.add(EGenMode.GenList, List__ElectroSpectrum__CS, 'List.Lists__ElectroSpectrum__CS');
  builder.add(EGenMode.GenList, List__ElectroSpectrum__EN, 'List.Lists__ElectroSpectrum__EN');
  builder.add(EGenMode.GenList, List__Planets__CS, 'List.Lists__Planets__CS');
  builder.add(EGenMode.GenList, List__Planets__EN, 'List.Lists__Planets__EN');
  builder.add(EGenMode.GenList, List__EarthLayers__CS, 'List.Lists__EarthLayers__CS');
  builder.add(EGenMode.GenList, List__EarthLayers__EN, 'List.Lists__EarthLayers__EN');
  builder.add(EGenMode.GenList, List__MohsScale__CS, 'List.Lists__MohsScale__CS');
  builder.add(EGenMode.GenList, List__MohsScale__EN, 'List.Lists__MohsScale__EN');
  builder.add(EGenMode.GenList, List__DigestivePath__CS, 'List.Lists__DigestivePath__CS');
  builder.add(EGenMode.GenList, List__DigestivePath__EN, 'List.Lists__DigestivePath__EN');
  builder.add(EGenMode.GenList, List__Presidents__CS, 'List.Lists__Presidents__CS');
  builder.add(EGenMode.GenList, List__Presidents__EN, 'List.Lists__Presidents__EN');
  builder.add(EGenMode.GenList, List__Alphabet__CS, 'List.Lists__Alphabet__CS');
  builder.add(EGenMode.GenList, List__Alphabet__EN, 'List.Lists__Alphabet__EN');
  builder.add(EGenMode.GenList, List__AlkaneSeries__CS, 'List.Lists__AlkaneSeries__CS');
  builder.add(EGenMode.GenList, List__AlkaneSeries__EN, 'List.Lists__AlkaneSeries__EN');
  builder.add(EGenMode.GenList, List__HumanLifeStages__CS, 'List.Lists__HumanLifeStages__CS');
  builder.add(EGenMode.GenList, List__HumanLifeStages__EN, 'List.Lists__HumanLifeStages__EN');
}
